/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const More: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <circle cx='3' cy='12' r='2' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
    <circle cx='12' cy='12' r='2' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
    <circle cx='21' cy='12' r='2' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
  </React.Fragment>
)
